module.exports = __webpack_public_path__ + "static/img/rz_13.dbc40e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rz_13.jpg
// module id = cLHE
// module chunks = 0